<template lang="pug">
.odds-wrapper
  .odds-group.border-0
    .col
      .m-label-top {{ leagueName.trim() }}
      template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
        OddsItem(:odds="details['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="b" :count="i" :details="details" homeAway="1")
      template(v-else)
        OddsDisabled
      template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
        OddsItem(:odds="details['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="s" :count="i" :details="details" homeAway="2")
      template(v-else)
        OddsDisabled
      template(v-if="details['oe'] && details['oe'][i] && details['oe'][i][5] != 0 && details['oe'][i][5] != ''")
        OddsItem(:odds="details['oe'][i]" idx=5 :typ="oddsType" dataType="2" homeAway="1" mode="oe")
      template(v-else)
        OddsDisabled
      template(v-if="details['oe'] && details['oe'][i] && details['oe'][i][7] != 0 && details['oe'][i][7] != ''")
        OddsItem(:odds="details['oe'][i]" idx=7 :typ="oddsType" dataType="2" homeAway="2" mode="oe")
      template(v-else)
        OddsDisabled

//- .match-bet-area-type
//-   .match-bet-area-type-title {{ leagueName.trim() }}
//-   .match-odd-area
//-     .match-odd-area-oddtype
//-       template(v-if="details['ou'][0][8] == 4.5")
//-         p.mb-0 B
//-         p.mb-0 S
//-       template(v-else)
//-         p.mb-0 {{ $t("m.ODD_Over") }}
//-         p.mb-0 {{ $t("m.ODD_Under") }}
//-     .match-odd-area-group
//-       template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
//-         OddsItem(:odds="details['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" :details="details" homeAway="1")
//-       template(v-else)
//-         OddsDisabled
//-       template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
//-         OddsItem(:odds="details['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" :details="details" homeAway="2")
//-       template(v-else)
//-         OddsDisabled
//-     .match-odd-area-oddtype
//-       template
//-         p.mb-0 {{ $t("m.ODD_Odd") }}
//-         p.mb-0 {{ $t("m.ODD_Even") }}
//-     .match-odd-area-group
//-       template(v-if="details['oe'] && details['oe'][i] && details['oe'][i][5] != 0 && details['oe'][i][5] != ''")
//-         OddsItem(:odds="details['oe'][i]" idx=5 :typ="oddsType" dataType="2")
//-       template(v-else)
//-         OddsDisabled
//-       template(v-if="details['oe'] && details['oe'][i] && details['oe'][i][7] != 0 && details['oe'][i][7] != ''")
//-         OddsItem(:odds="details['oe'][i]" idx=7 :typ="oddsType" dataType="2")
//-       template(v-else)
//-         OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    },
  },
  computed: {
    leagueName() {
      var result = this.details["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1];
      }
      return this.details["league"];
    }
  }
};
</script>